import { render, staticRenderFns } from "./custom-e-signature.vue?vue&type=template&id=2507248a&scoped=true&"
import script from "./custom-e-signature.vue?vue&type=script&lang=js&"
export * from "./custom-e-signature.vue?vue&type=script&lang=js&"
import style0 from "./custom-e-signature.vue?vue&type=style&index=0&id=2507248a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2507248a",
  null
  
)

export default component.exports